import createPdf from './base.js';
import { logo_pdf } from 'assets/img/logo-pdf.js'


const tratamientoPdf = async (output, { paciente, listaTratamiento }) => {


  let edad_años = 0
  let edad_meses = 0
  let edad_dias = 0

  let edadBD = paciente[0].fecha_nac
  let hoy = new Date();
  let fechaDeNacimiento = new Date(edadBD);
  edad_años = hoy.getFullYear() - fechaDeNacimiento.getFullYear();;
  edad_meses = hoy.getMonth() - fechaDeNacimiento.getMonth();
  edad_dias = hoy.getDate() - fechaDeNacimiento.getDate();

  if (edad_dias < 0) {
    const mesAnterior = new Date(hoy.getFullYear(), hoy.getMonth(), 0);
    edad_dias += mesAnterior.getDate();
    edad_meses--;
  }

  if (edad_meses < 0) {
    edad_años--;
    edad_meses += 12;
  }




  let titulo = 'AREA DE DIAGNOSTICO Y TRATAMIENTO - PROGRAMA ETVS'
  let subtitulo = 'TRATAMIENTO'

  const content = [
    {
      margin: [0, 0, 0, 0],
      table: {
        widths: ['30%', '50%', '20%'],
        body: [
          [
            {
              image: logo_pdf,
              fit: [130.73, 60.692],
              alignment: 'left',
              margin: [0, 0, 0]
            },
            { text: titulo, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fontSize: 14 },
            { text: 'CODIGO                ', style: 'header', alignment: 'left', margin: [2, 5, 0, 0], fontSize: 12},
          ],
          [
            {},
            { text: subtitulo, style: 'titulo', alignment: 'center', },
            { text: 'N°' + listaTratamiento[0].id, style: 'text', alignment: 'rigth', margin: [3, 0, 0, 10], color: 'red', fontSize: 10 },
          ],
        ],
      },
      layout: 'noBorders',
    },

    //TIPO Y NUMERO DOCUMENTO


    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '1. TRATAMIENTO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },
    {
      margin: [0, 0, 0, 0],

      table: {
        widths: ['20%', '20%', '20%', '20%', '22%',],
        body: [
          [
            { text: 'DEPARTAMENTO', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Coordenacion de Red', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Municipio', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Est. de salud', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'MEDICO', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fontSize: 6, fillColor: '#eaeded' },

          ],
          [
            { text: 'CHUQUISACA', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], },
            { text: listaTratamiento[0]?.red, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0] },
            { text: listaTratamiento[0]?.municipio, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0] },
            { text: listaTratamiento[0]?.hospital, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], },
            { text: listaTratamiento[0]?.usuario, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fontSize: 6, },

          ],

        ],
      },








      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },

      }


    },

    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '2. DATOS DEL PACIENTE', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },

    {
      margin: [0, 0, 0, 0],

      table: {
        widths: ['19%', '16%', '16%', '20%', '18%', '13%',],
        body: [
          [
            { text: 'Nombre', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Apelido paterno', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Apellido materno', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'sexo', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded', },
            { text: 'Edad', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },
            { text: 'Cedula de identidad', style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], fillColor: '#eaeded' },

          ],
          [
            { text: paciente[0].nombre, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], },
            { text: paciente[0].ap1, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], },
            { text: paciente[0].ap2 ? paciente[0].ap2 : null, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0] },
            {
              table: {
                widths: ['50%', '50%'],
                body: [
                  [
                    { text: 'Masculino', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                    { text: 'Femenino', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                  ],
                  [
                    { text: paciente[0].sexo == 1 ? 'Si' : '-', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                    { text: paciente[0].sexo == 2 ? 'Si' : '-', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                  ],
                ],
              },
              layout: {
                hLineColor: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
                },
                vLineColor: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
                },
              }
            },
            {
              table: {
                widths: ['31%', '39%', '30%'],
                body: [
                  [
                    { text: 'Años', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                    { text: 'Meses', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                    { text: 'Dias', style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                  ],
                  [
                    { text: edad_años, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                    { text: edad_meses, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                    { text: edad_dias, style: 'subtitulo', alignment: 'center', margin: [0, 0, 0, 0] },
                  ],
                ],
              },
              layout: {
                hLineColor: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
                },
                vLineColor: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
                },
              }

            }
            ,
            { text: paciente[0].ci ? paciente[0].ci : 'TUTOR: ' + paciente[0].ci_tutor, style: 'subtitulo', alignment: 'center', margin: [2, 5, 0, 0], },
          ],

        ],
      },
    },





    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '3. RESULTADOS', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },


    {
      table: {
        widths: ['52%', '50%'],
        body: [
          [
            { text: 'Situacion Epidemica', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'PostTratamiento', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
          ],
          [
            { text: listaTratamiento[0].epidemica, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
            { text: listaTratamiento[0].id_post_tratamiento ? listaTratamiento[0].id_post_tratamiento == 1 ? 'SI' : 'NO' : '-', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
          ],
        ],
      },

    },


    {
      table: {
        widths: ['102%',],
        body: [
          [
            { text: 'Situacion Epidemica', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
          ],
          [
            { text: listaTratamiento[0].complementarios, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
          ],
        ],
      },
    },


    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '3. TRATAMIENTO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },


    {
      table: {
        widths: ['25%', '25%', '25%', '27%',],
        body: [
          [
            { text: 'Peso (Kg.)', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'TA(mmHg)', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'Temperatura(°c)', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'Frec. cardiaca(Ipm)', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
          ],
          [
            { text: listaTratamiento[0].peso, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
            { text: listaTratamiento[0].presion_arterial, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
            { text: listaTratamiento[0].temperatura, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
            { text: listaTratamiento[0].f_cardiaca, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
          ],
        ],
      },
    },



    {
      table: {
        widths: ['25%', '25%', '25%', '27%',],
        body: [
          [
            { text: 'MEDICAMENTO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'DOSIS', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'FECHA INICIO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'FECHA CONCLUSION', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
          ],
          [
            { text: listaTratamiento[0].medicamento, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
            { text: listaTratamiento[0].dosis, style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
            { text: listaTratamiento[0].fecha_inicio.split('T')[0], style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
            { text: listaTratamiento[0]?.fecha_conclusion?.split('T')[0] || '', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
          ],
        ],
      },
    },

    {
      table: {
        widths: ['25%', '25%', '25%', '27%',],
        body: [
          [
            { text: 'SUSPENCION', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'ABANDONO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'PRE QUIRURGICO', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
            { text: 'HOSPTAL REF.', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, fillColor: '#eaeded' },
          ],
          [
            { text: listaTratamiento[0].suspension || '-', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
            { text: listaTratamiento[0].abandono || '-', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
            { text: listaTratamiento[0].pre_quirurgico || '-', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
            { text: listaTratamiento[0]?.hospital_ref || '-', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6, },
          ],
        ],
      },
    },









    {
      table: {
        widths: ['102%'],
        body: [
          [
            { text: '4. REACCIONES ADVERSAS', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#d0ece7' },
          ],
        ],
      },
    },




    {
      table: {
        widths: ['25%', '25%', '25%', '27%'],
        body: [
          [
            { text: 'Reacción Dermatológica', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#eaeded' },
            { text: 'Reacción Digestiva', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#eaeded' },
            { text: 'Reacción Neurológica', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#eaeded' },
            { text: ' Reacción Hematológica', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fillColor: '#eaeded' },
          ],
          [
            { text: listaTratamiento[0].reaccionDermatologica || '-', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: listaTratamiento[0].reaccionDigestiva || '-', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: listaTratamiento[0].reaccionNeurologica || '-', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
            { text: listaTratamiento[0].reaccionHematologica || '-', style: 'subtitulo', alignment: 'left', margin: [0, 0, 0, 0], fontSize: 6 },
          ],
        ],
      },

      layout: {
        hLineColor: function (i, node) {
          return (i === 0 || i === node.table.body.length) ? '#000000' : '#000000';
        },
        vLineColor: function (i, node) {
          return (i === 0 || i === node.table.widths.length) ? '#000000' : '#000000';
        },
      }
    },

    { text: listaTratamiento[0].observacion ? ' Observaciones: ' + listaTratamiento[0].observacion : 'Observaciones:_____________________________________________________________________________________________________________________________________________________', style: 'subtitulo', margin: [0, 10, 0, 10], fontSize: 6, alignment: 'left' },

    { text: '__________________________________________________________________________', style: 'piePagina', alignment: 'center', margin: [0, 50, 0, 0], },
    { text: 'PROFESIONAL MEDICO', style: 'text', alignment: 'center', },
    { text: listaTratamiento[0].usuario, style: 'piePagina', alignment: 'center', },

  ];

  const response = await createPdf({ content }, output);
  return response;
};

export { tratamientoPdf };
